$(document).ready(function(){
  $('span.quick-view-button').click(function(){
    console.log("test")
  })
})

var ur = window.location.href;

  jQuery(document).ready(function(){
      $('span.quick-view-button').click(function(){
          var q = $(this).closest('.grid__item');
        var qv = 0; var timerqv = setInterval(function(){
          if(q.find('.qview-button').length) {
        q.find('.qview-button').eq(0).click();
      clearInterval(timerqv);}if( qv > 200){clearInterval(timerqv);}qv++;}, 50);

      }); 
});